import OSS from 'ali-oss'
import Vue from 'vue'

export default class OSSClient {

    static createClient(): OSS {
        return new OSS({
            region: Vue.prototype.filePre$.region,
            accessKeyId: Vue.prototype.filePre$.accessKeyId,
            accessKeySecret: Vue.prototype.filePre$.accessKeySecret,
            bucket: Vue.prototype.filePre$.bucket,
        })
    }

    static multipartUpload(client: OSS, ossFilePath: string, newFile: File) {
        return new Promise((resolve, reject) => {
            client.multipartUpload(ossFilePath, newFile
                , {
                    // progress: function (p, checkpoint) {
                    //     item.isShowProgress = true
                    //     // let percent = Math.round(transferredAmount * 100.0 / totalAmount)
                    //     item.percent = Math.round(p * 100.0)
                    // },
                    // checkpoint: tempCheckpoint,
                    // meta: { year: 2020, people: 'test' },
                    contentType: 'application/x-www-form-urlencoded',
                }).then(function (res) {
                console.log(res)
                resolve(res);
            }).catch(function (err) {
                console.log(err)
                reject(err);
            })
        })
    }
}
